// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 695) return "695.0c4e4289bc2d01a1d33d.css";
	if (chunkId === 716) return "canvas.b25101e27325d95dacca.css";
	// return url for filenames based on template
	return undefined;
};